import React from "react";
// components
import FormRequest from "../../components/FormRequest";
// styles
import styles from "./forms.module.css";

export default function LimitedWarranty() {
  const message =
    "Form submitted! \nYour request has been received. Once a decision has been made about your request, you will be notified via email. Thank you.";

  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title}>
        GIAPREZA (angiotensin II) Limited Warranty Return Form
      </h2>

      <FormRequest
        dateField={{
          name: "administrationDate",
          label: "Date of GIAPREZA Administration",
        }}
        formName={"limited_warranty_form"}
        formNameReadable={"Limited Warranty Program"}
        formPageName="warranty"
        submissionMessage={message}
      />
    </div>
  );
}
